export default __webpack_public_path__ + "static/media/Reader's Boots of Twining Smoke.c2f6b354.jpg";